import { faClock, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import FroalaEditor from 'react-froala-wysiwyg';
import NotificationHistory from './NotificationHistory';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import { toast } from 'react-toastify';

class EmailNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enabled: true,
            daysBefore: '1',
            isEmailNotification: true,
            hostNameValue: '',
            userNameValue: '',
            passwordValue: '',
            portValue: '',
            secureValue: '',
            emailToValue: '',
            senderNameValue: '',
            emailSubjectValue: '',
            emailMessageValue: '',

            addParameterValues: [
                { name: "Resource_Title", value: 'Resource_Title' },
                { name: "accession_series", value: 'accession_series' },
                { name: "accession_number", value: 'accession_number' },
                { name: "Resource_Author", value: 'Resource_Author' },
                { name: "User_Role", value: 'User_Role' },
                { name: "User_first_Name", value: 'User_first_Name' },
                { name: "User_Last_Name", value: 'User_Last_Name' },
                { name: "Issued_Date", value: 'Issued_Date' },
                { name: "Due_Date", value: 'Due_Date' },
                { name: "Fine_Per_Day", value: 'Fine_Per_Day' },
                { name: "Applicable_Fine", value: 'Applicable_Fine' },
                { name: "College_Name", value: 'College_Name' }
            ],

            // VARIABLES TO display notification history
            isShowNotificationHistory: false,

            emailSettingDataList: [],
            totalEmilSetting: 0,

            smtpTestConnectResponse: false,
        };
    }

    componentDidMount() {
        this.apiCallToGetPushNotificationData();
    }

    // API CALL TO GET Push notification DATA LIST
    apiCallToGetPushNotificationData = async () => {
        let requestData = {
            "iid": config.institute_id,
            "type": "email"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetPushNotificationData();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (Object.values(apiResult?.data)?.length > 0) {
                    if (apiResult.success == 'true') {
                        const notificationData = Object.values(apiResult.data)[0];

                        this.setState({
                            emailSettingDataList: apiResult.data,
                            totalEmilSetting: apiResult.totalCount,
                        })

                        this.setState({
                            isEmailNotification: notificationData.access === "true" ? true : false,
                            daysBefore: Number(notificationData.days),
                            hostNameValue: notificationData.hostName,
                            userNameValue: notificationData.userName,
                            passwordValue: notificationData.password,
                            portValue: notificationData.port,
                            secureValue: notificationData.smtpSecure,
                            emailToValue: notificationData.senderEmailId,
                            senderNameValue: notificationData.senderName,
                            emailSubjectValue: notificationData.emailSubject,
                            emailMessageValue: notificationData.emailText,
                        })
                    }
                    else {
                        this.setState({
                            emailSettingDataList: [],
                            totalEmilSetting: 0,
                        })
                    }
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        emailSettingDataList: [],
                        totalEmilSetting: 0,
                    })
                    this.setState({
                        daysBefore: '1',
                        isEmailNotification: true,
                        hostNameValue: '',
                        userNameValue: '',
                        passwordValue: '',
                        portValue: '',
                        secureValue: '',
                        emailToValue: '',
                        senderNameValue: '',
                        emailSubjectValue: '',
                        emailMessageValue: '',
                    })
                }
            } else {
                this.setState({
                    emailSettingDataList: [],
                    totalEmilSetting: 0,
                })
            }
        }
    }

    handleToggle = () => {
        this.setState(prevState => ({
            enabled: !prevState.enabled
        }));
    };

    handleDaysChange = (event) => {
        this.setState({ daysBefore: event.target.value });
    };

    handleToggleStatus = (isEmailNotification) => {
        this.setState({ isEmailNotification: !isEmailNotification });
    }

    // close modal for notification history
    closeModalForNotificationHistory = () => {
        this.setState({
            isShowNotificationHistory: false
        })
    }

    // METHOD TO UPDATE email content
    handleContentChange = (e) => {
        this.setState({
            emailMessageValue: e,
        });
    }

    // add email notification
    library_AddSmtpNotification = async () => {
        let requestData = {
            "iid": config.institute_id,
            "type": "email",
            "access": this.state.isEmailNotification ? "true" : "false",
            "days": Number(this.state.daysBefore),
            "hostName": this.state.hostNameValue,
            "userName": this.state.userNameValue,
            "password": this.state.passwordValue,
            "smtpSecure": this.state.secureValue,
            "port": this.state.portValue,
            "senderEmailId": this.state.emailToValue,
            "senderName": this.state.senderNameValue,
            "emailSubject": this.state.emailSubjectValue,
            "emailText": this.state.emailMessageValue,
            "addedBy": config.faculty_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_AddSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        )

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_AddSmtpNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetPushNotificationData();

                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting mobile configuration setting. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // update email notification
    library_UpdateSmtpNotification = async () => {
        let requestData = {
            "iid": config.institute_id,
            "access": this.state.isEmailNotification ? "true" : "false",
            "days": Number(this.state.daysBefore),
            "hostName": this.state.hostNameValue,
            "userName": this.state.userNameValue,
            "password": this.state.passwordValue,
            "smtpSecure": this.state.secureValue,
            "port": this.state.portValue,
            "senderEmailId": this.state.emailToValue,
            "senderName": this.state.senderNameValue,
            "emailSubject": this.state.emailSubjectValue,
            "emailText": this.state.emailMessageValue,
            "updatedBy": config.faculty_id,
            "uniqueId": Object.values(this.state.emailSettingDataList)[0].uniqueId
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_UpdateSmtpNotification',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        )

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_UpdateSmtpNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetPushNotificationData();

                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting mobile configuration setting. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    handleOnClick = () => {
        if (Object.values(this.state.emailSettingDataList).length === 0) {
            this.library_AddSmtpNotification()
        } else {
            this.library_UpdateSmtpNotification()
        }
    }

    // METHOD TO ADD PARAMETER
    addParameter = (parameter) => {
        let { emailMessageValue } = this.state;
        let updatedMessage = emailMessageValue + ` {${parameter}}`;
        this.setState({
            emailMessageValue: updatedMessage
        });
    }

    isFormValid = () => {
        const {
            isEmailNotification,
            daysBefore,
            hostNameValue,
            userNameValue,
            passwordValue,
            secureValue,
            portValue,
            senderNameValue,
            emailSubjectValue,
            emailMessageValue
        } = this.state;

        if (!isEmailNotification) return true;

        return (
            String(daysBefore).trim() !== '' &&
            String(hostNameValue).trim() !== '' &&
            String(userNameValue).trim() !== '' &&
            String(passwordValue).trim() !== '' &&
            String(secureValue).trim() !== '' &&
            String(portValue).trim() !== '' &&
            String(senderNameValue).trim() !== '' &&
            String(emailSubjectValue).trim() !== '' &&
            String(emailMessageValue).trim() !== ''
        );
    };

    library_SMTPTestConnection = async () => {
        let requestData = {
            "hostName": this.state.hostNameValue,
            "port": this.state.portValue,
            "userName": this.state.userNameValue,
            "password": this.state.passwordValue,
            "encryption": this.state.secureValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_SMTPTestConnection',
            requestData,
            "/api/library/librarySmtpNotificationSetting.php"
        )

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_SMTPTestConnection();
            }, 1000);
        } else {
            const response = jsonResponse.APIResult.connection_response;

            if (response?.success) {
                toast.success(response.message || "SMTP connected successfully.", {
                    position: "top-right",
                    autoClose: 2000,
                });

                this.setState({ smtpTestConnectResponse: true });
            } else {
                toast.warn(response?.message || "SMTP connection failed.", {
                    position: "top-right",
                    autoClose: 2000,
                });

                this.setState({ smtpTestConnectResponse: false });
            }
        }
    }


    handleOnTestConnection = () => {
        this.library_SMTPTestConnection()
    }


    render() {
        return (
            <>
                <div className="notification-container">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3 pe-2 d-flex-with-gap">
                            <span className="textHeadingLabel me-3">Enable /Disable E-mail Notification</span>
                            <span
                                onClick={() => this.handleToggleStatus(this.state.isEmailNotification)}
                                style={{
                                    display: 'inline-block',
                                    width: '30px',
                                    height: '16px',
                                    borderRadius: '9.5px',
                                    backgroundColor: this.state.isEmailNotification ? '#0465ac' : 'grey',
                                    position: 'relative',
                                    cursor: 'pointer',
                                }}
                            >
                                <span
                                    style={{
                                        display: 'block',
                                        width: '10px',
                                        height: '10px',
                                        borderRadius: '50%',
                                        backgroundColor: '#fff',
                                        position: 'absolute',
                                        top: '3px',
                                        left: this.state.isEmailNotification ? '16px' : '1px',
                                        transition: 'left 0.3s ease',
                                    }}
                                ></span>
                            </span>
                        </div>

                        <button className="btn btn-outline btn-sm custom-button" onClick={() => {
                            this.setState({
                                isShowNotificationHistory: true
                            });
                        }}>
                            <FontAwesomeIcon icon={faClock} className="me-1 mr-2" />
                            Notification Logs
                        </button>
                    </div>

                    <div className="custom-boarder-width mt-4">
                        <span className="stepsNotificationLabel">Steps to set up E-mail Notification</span>
                        <ul className="mt-2 ml-2 p-2">
                            <li className="textHeadingLabel mb-2">
                                This system can securely integrate with E-mails.
                            </li>
                            <li className="textHeadingLabel mb-2">
                                You have to create a pre defined content and subject in order to send an e-mail.
                            </li>
                            <li className="textHeadingLabel">
                                This E-mail will be triggered
                                <select
                                    className={`form-select form-select-sm custom-select w-auto mx-2`}
                                    value={this.state.daysBefore}
                                    onChange={this.handleDaysChange}
                                >
                                    <option value="1">1 Day</option>
                                    <option value="2">2 Days</option>
                                    <option value="3">3 Days</option>
                                </select>
                                before due date.
                            </li>
                            <li className="textHeadingLabel mb-2">
                                You will have access to the key for each field. kindly mention required key and value in the respective fields.
                            </li>
                            <li className="textHeadingLabel mb-2">
                                This is the default email template. If you need to make changes, you can update the template below.
                            </li>
                        </ul>
                    </div>

                    <div className="custom-boarder-width mt-4">
                        <span className="stepsNotificationLabel">Key Details</span>
                        <div className="row g-3 pt-2 pb-2">
                            {/* Row 1 */}
                            <div className="col-md-4 d-flex flex-column p-2 p-2">
                                <div className="d-flex align-items-center gap-3 pe-2 gap-3 pe-2">
                                    <label className="custom-label me-2 w-50 text-end pe-2 pe-2">Host Name</label>
                                    <input
                                        type="text"
                                        className={`custom-inputField form-control`}
                                        placeholder="Enter Host Name"
                                        value={this.state.hostNameValue}
                                        onChange={(e) => this.setState({ hostNameValue: e.target.value })}
                                    />
                                </div>
                                {this.state.isEmailNotification && !this.state.hostNameValue && (
                                    <div className="invalid-feedback d-block text-start ps-5 ms-5">Host Name is required.</div>
                                )}
                            </div>

                            <div className="col-md-4 d-flex flex-column p-2">
                                <div className="d-flex align-items-center gap-3 pe-2">
                                    <label className="custom-label me-2 w-50 text-end pe-2">Sender Email</label>
                                    <input
                                        type="text"
                                        className={`custom-inputField form-control`}
                                        placeholder="Enter Sender Email"
                                        value={this.state.userNameValue}
                                        onChange={(e) => this.setState({ userNameValue: e.target.value })}
                                    />
                                </div>
                                {this.state.isEmailNotification && !this.state.userNameValue && (
                                    <div className="invalid-feedback d-block text-start ps-5 ms-5">Sender Email is required.</div>
                                )}
                            </div>

                            <div className="col-md-4 d-flex flex-column p-2">
                                <div className="d-flex align-items-center gap-3 pe-2">
                                    <label className="custom-label me-2 w-50 text-end pe-2">Password</label>
                                    <input
                                        type="password"
                                        className={`custom-inputField form-control`}
                                        placeholder="Enter Password"
                                        value={this.state.passwordValue}
                                        onChange={(e) => this.setState({ passwordValue: e.target.value })}
                                    />
                                </div>
                                {this.state.isEmailNotification && !this.state.passwordValue && (
                                    <div className="invalid-feedback d-block text-start ps-5 ms-5">Password is required.</div>
                                )}
                            </div>

                            {/* Row 2 */}
                            <div className="col-md-4 d-flex flex-column p-2">
                                <div className="d-flex align-items-center gap-3 pe-2">
                                    <label className="custom-label me-2 w-50 text-end pe-2">SMTP Secure</label>
                                    <input
                                        type="text"
                                        className={`custom-inputField form-control`}
                                        placeholder="Enter SMTP Secure"
                                        value={this.state.secureValue}
                                        onChange={(e) => this.setState({ secureValue: e.target.value })}
                                    />
                                </div>
                                {this.state.isEmailNotification && !this.state.secureValue && (
                                    <div className="invalid-feedback d-block text-start ps-5 ms-5">SMTP Secure is required.</div>
                                )}
                            </div>

                            <div className="col-md-4 d-flex flex-column p-2">
                                <div className="d-flex align-items-center gap-3 pe-2">
                                    <label className="custom-label me-2 w-50 text-end pe-2">Port</label>
                                    <input
                                        type="text"
                                        className={`custom-inputField form-control`}
                                        placeholder="Enter Port"
                                        value={this.state.portValue}
                                        onChange={(e) => this.setState({ portValue: e.target.value })}
                                    />
                                </div>
                                {this.state.isEmailNotification && !this.state.portValue && (
                                    <div className="invalid-feedback d-block text-start ps-5 ms-5">Port is required.</div>
                                )}
                            </div>

                            {/* Uncomment this block if you use Sender Email */}
                            {/*
                            <div className="col-md-4 d-flex flex-column p-2">
                                <div className="d-flex align-items-center gap-3 pe-2">
                                <label className="custom-label me-2 w-50 text-end pe-2">Sender E-mail ID</label>
                                <input
                                    type="email"
                                    className={`custom-inputField form-control ${this.state.isEmailNotification && !this.state.emailToValue ? 'is-invalid' : ''}`}
                                    placeholder="Enter Sender E-mail ID"
                                    value={this.state.emailToValue}
                                    onChange={(e) => this.setState({ emailToValue: e.target.value })}
                                />
                                </div>
                                {this.state.isEmailNotification && !this.state.emailToValue && (
                                <div className="invalid-feedback d-block text-start ps-5 ms-5">Sender E-mail ID is required.</div>
                                )}
                            </div>
                            */}

                            {/* Row 3 */}
                            <div className="col-md-4 d-flex flex-column p-2">
                                <div className="d-flex align-items-center gap-3 pe-2">
                                    <label className="custom-label me-2 w-50 text-end pe-2">Sender Name</label>
                                    <input
                                        type="text"
                                        className={`custom-inputField form-control`}
                                        placeholder="Enter Sender Name"
                                        value={this.state.senderNameValue}
                                        onChange={(e) => this.setState({ senderNameValue: e.target.value })}
                                    />
                                </div>
                                {this.state.isEmailNotification && !this.state.senderNameValue && (
                                    <div className="invalid-feedback d-block text-start ps-5 ms-5">Sender Name is required.</div>
                                )}
                            </div>
                        </div>

                    </div>

                    <div className="custom-boarder-width mt-3">
                        <div className="d-flex justify-content-between align-items-center row mb-3">
                            <div className="col-md-3 d-flex flex-column">
                                <label className="custom-label mb-1">E-mail Subject</label>
                                <input
                                    type="text"
                                    className={`custom-inputField form-control`}
                                    placeholder="Enter E-mail Subject"
                                    value={this.state.emailSubjectValue}
                                    onChange={(e) => {
                                        this.setState({ emailSubjectValue: e.target.value });
                                    }}
                                />
                                {this.state.isEmailNotification && !this.state.emailSubjectValue && (
                                    <div className="invalid-feedback d-block text-start mt-1" style={{ color: '#dc3545' }}>
                                        E-mail Subject is required.
                                    </div>
                                )}
                            </div>

                            <div>
                                <div className="d-flex justify-content-end mb-1">
                                    <button className="btn btn-outline btn-sm custom-button" id='orderByDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" >
                                        <FontAwesomeIcon id='orderByDropdownMenu' icon={faPlus} className="me-1 mr-2" />
                                        Add Parameters
                                    </button>
                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='orderByDropdownMenu'>
                                        <div id='addParameterDropdown'>
                                            {
                                                this.state.addParameterValues.map((columnInfo, index) => {
                                                    // Determine if the current column is selected
                                                    const isSelected = this.state.isOrderByResourcesValue === columnInfo.value;
                                                    return (
                                                        <p className="dropdown-item" style={{
                                                            display: 'flex', justifyContent: 'space-between', fontSize: '14px', backgroundColor: isSelected ? '#e0f7fa' : 'transparent', // Highlight background if selected
                                                            color: isSelected ? '#0465AC' : 'black', // Change text color if selected
                                                            cursor: 'pointer', padding: '10px'
                                                        }} key={columnInfo.name} onClick={() => this.addParameter(columnInfo.name)}>
                                                            <span
                                                                style={{ marginRight: 10, cursor: 'pointer' }}
                                                            >
                                                                {columnInfo.name}
                                                            </span>
                                                        </p>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="custom-boarder-width mt-4">
                        <FroalaEditor
                            model={this.state.emailMessageValue}
                            onModelChange={this.handleContentChange}
                            config={{
                                height: 400,
                                key: this.state.froala_auth_key,
                                attribution: false,
                                zIndex: 1,
                                toolbarButtons: [
                                    'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|',
                                    'fontFamily', 'fontSize', 'color', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|',
                                    'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'clearFormatting', '|', 'html',
                                    '|', 'tableInsertRowAfter', 'tableInsertRowBefore', 'tableInsertColumnAfter', 'tableInsertColumnBefore',
                                    'tableDeleteRow', 'tableDeleteColumn', 'textColor'
                                ],
                                pluginsEnabled: [
                                    'tooltips', 'align', 'codeBeautifier', 'codeView', 'colors', 'draggable',
                                    'emoticons', 'fontSize', 'fullscreen', 'image', 'link', 'lists',
                                    'paragraphFormat', 'paragraphStyle', 'quickInsert', 'table', 'url', 'wordPaste'
                                ],
                                placeholderText: 'Edit Your Content Here!',
                                quickInsertTags: [''],
                                charCounterCount: true,
                            }}
                        />
                        {this.state.isEmailNotification && !this.state.emailMessageValue && (
                            <div className="invalid-feedback d-block text-start mt-1" style={{ color: '#dc3545' }}>
                                E-mail Message is required.
                            </div>
                        )}
                    </div>


                    <div className="custom-boarder-width mt-4">
                        {
                            this.state.isEmailNotification
                                ? (
                                    this.state.smtpTestConnectResponse
                                        ? <button className="btn btn-primary" onClick={() => this.handleOnClick()} disabled={!this.isFormValid()}>Save</button>
                                        : <button className="btn btn-primary" onClick={() => this.handleOnTestConnection()} disabled={!this.isFormValid()}>Test Connection</button>
                                )
                                : (
                                    <button className="btn btn-primary" onClick={() => this.handleOnClick()} disabled={!this.isFormValid()}>Save</button>
                                )
                        }
                    </div>
                </div >

                {
                    <NotificationHistory
                        isShowNotificationHistory={this.state.isShowNotificationHistory}
                        closeModalForNotificationHistory={this.closeModalForNotificationHistory}
                        headerName={"E-mail"}
                        type="email"
                    />
                }
            </>
        )
    }
}

export default EmailNotification;